<template>
<div class="header">
    <div class="v2" v-if="designVersion === 2">
        <div class="header-icons-wrapper">
            <img class="header-icons" src="/assets/images/fitness-icon-hero.svg" alt="fitness-icon-hero">
            <img class="header-icons" src="/assets/images/autobahn-icon-small.svg" alt="autobahn-icon-small">
            <img class="header-icons" src="/assets/images/plus-icon-hero.svg" alt="plus-icon-hero">
        </div>
        <heading :level="'h1'">{{ title }}</heading>
        <paragraph class="subtitle center" :class="{'hidden': isSubmitting}" v-if="subtitle" :type="'p'" :variation="'medium'" v-html="subtitle"></paragraph>
    </div>
    <div class="v1" v-else>
        <div class="logo-container">
            <div :style="logo" class="logo"></div>
        </div>
        <div>{{ title }}</div>
        <svg width="182" height="50" class="number-slider" v-if="cardIndex >= 0">
            <line x1="15" y1="20" x2="160" y2="20"/>
            <circle v-for="index in 4" :cx="15 + 50*(index-1)" cy="20" r="15" :class="{'selected': cardIndex == index}" :key="index"/>
            <text v-for="index in 4" :x="10 + 50*(index-1)" y="26" :key="index">{{index}}</text>
        </svg>
    </div>
</div>
</template>

<script>
import Heading from '~/components/shared/heading.vue';
import Paragraph from '~/components/shared/paragraph.vue';

export default {
    components: { Heading, Paragraph },
    props: {
        // eslint-disable-next-line vue/require-prop-type-constructor
        cardIndex: 0,
        designVersion: {
            type: Number,
            default: 1,
        },
        title: String,
        subtitle: String,
        isSubmitting: Boolean,
    },
    computed: {
        logo() {
            const logo = this.getBrandingVar('card_logo');
            return `background-image: url('${logo}');`;
        },
    },
};
</script>

<style lang="scss" scoped>
$darker-blue: #174F79;
.header {

    .v1 {
        background-color: $dark-blue;
        border-radius: 0 0 100px 0;
        position: relative;
        color: white;
        font-size: 1.5rem;
        font-weight: 600;
        text-align: center;
        padding: 2rem 1.5rem;
        .logo-container {
            border-radius: 50%;
            // background: white;
            width: 90px !important;
            height: 90px;
            position: relative;
            margin: 0 auto;
            margin-bottom: 0.5rem;
            .logo {
                height: 90px !important;
                width: 90px !important;
                // position: absolute;
                top: 10px;
                left: 10px;
                margin-bottom: 1rem;
                background-repeat: no-repeat;
                background-size: contain;
            }
        }
    }

    .v2 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 3.692rem;
        padding-left: 1.231rem;
        padding-right: 1.231rem;
        padding-bottom: 0;

        @media only screen and (max-width: 600px) {
            padding-top: 1.846rem;
        }

        .paragraph {
            margin-bottom: 0;
        }

        .header-icons-wrapper {
            width: 60%;
            display: flex;
            justify-content: space-evenly;
            margin-bottom: 1rem;

            .header-icons {
                width: 30%;
                max-width: 105px;
            }
        }

        .heading {
            font-weight: $font-weight-h2;
        }
    }
}
.number-slider {
    font-size: 16px;
    text {
        fill: $dark-blue;
    }
    line {
        stroke: $darker-blue;
        stroke-width: 3;
    }
    circle {
        fill: #4B779A;
        stroke: $darker-blue;
        stroke-width: 3;
        &.selected {
            fill: white;
            stroke: none;
        }
    }
}
.hidden {
    visibility: hidden;
}
</style>
